import { render } from "./MdOverlay.vue?vue&type=template&id=558be5ac"
import script from "./MdOverlay.vue?vue&type=script&lang=js"
export * from "./MdOverlay.vue?vue&type=script&lang=js"

import "./MdOverlay.vue?vue&type=style&index=0&id=558be5ac&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__